module.exports = __webpack_public_path__ + "images/emoji/fallen_leaf.0096a579f5e603543996.png";